import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Loader from 'react-loader-spinner';
import { Checkbox, Radio } from 'semantic-ui-react';

const genderIds = [93, 94, 95];

const ExceptCategoryBlock = ({
  title,
  tags,
  category,
  setExceptCategories,
  categoryIngredients,
  setGenderValue,
}) => {
  const [genderValue, setGender] = useState('Женский');
  let gender = [];

  const setRadioButton = (name) => {
    category.forEach((categoryId, i) => {
      // TODO: переделать
      genderIds.forEach((id) => {
        if (categoryId === id) {
          category.splice(i, 1);
        }
      });
    });
    setGender(name);
    const genderTag = gender.find((item) => item.name === name);
    setGenderValue(genderTag.tag_id);
  };
  useEffect(() => {
    if (gender.length !== 0) {
      const genderTag = gender.find((item) => item.name === genderValue);
      setGenderValue(genderTag.tag_id);
    }
  }, [gender]);

  useEffect(() => {
    if (categoryIngredients === 4 && category.length) {
      let genderTagId = '';
      category.forEach((categoryId) => {
        genderIds.forEach((id) => {
          if (categoryId === id) {
            genderTagId = categoryId;
          }
        });
      });
      const genderTag = gender.find((item) => item.tag_id === genderTagId);
      if (genderTag && genderTag.name) {
        setGender(genderTag.name);
        setGenderValue(genderTag.tag_id);
      }
    }
  }, [category]);

  const handleCheck = (tag) => {
    category.forEach((categoryId, i) => {
      genderIds.forEach((id) => {
        if (categoryId === id) {
          category.splice(i, 1);
        }
      });
    });
    let choosedTagsIds = JSON.parse(JSON.stringify(category));
    if (choosedTagsIds.includes(tag.tag_id)) {
      choosedTagsIds = choosedTagsIds.filter((choosedTagId) => choosedTagId !== tag.tag_id);
    } else {
      choosedTagsIds.push(tag.tag_id);
    }
    setExceptCategories(choosedTagsIds);
  };

  if (tags) {
    tags = tags.filter((tag) => tag.category_id === categoryIngredients);
    if (categoryIngredients === 4) {
      gender = tags.slice(0, 3);
      tags.splice(0, 3);
    }
  }

  const WrapTagCheckbox = styled.div`
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    cursor: pointer;
    width: auto;
    margin: 5px 5px;
    width: ${categoryIngredients !== 4 ? '200px' : '100px'};
    font-size: 18px;
  `;

  const CheckboxWrapper = styled.div`
    width: ${categoryIngredients !== 4 ? '100%' : '430px'};
    box-sizing: border-box;
    padding: 10px 25px;
    border: 1px solid #c1c1c1;
    background: #fff;
    border-radius: 5px;
    box-shadow: 3px 3px 2px #afafaf;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: ${(props) => (props.itemsCenter ? 'center' : 'space-around')};
  `;

  const EmptyFilterBlock = styled.div`
    width: ${categoryIngredients !== 4 ? '200px' : '100px'};
    margin: 0px 5px;
  `;
  return (
    <div>
      <H1>{title}</H1>
      <CheckboxWrapper itemsCenter={!tags && !tags.length}>
        {!tags && !tags.length && (
          <Loader type="Ball-Triangle" color="#3a3a3a" height="60" width="60" />
        )}
        {gender &&
          gender.map((tag) => (
            <WrapTagCheckbox key={tag.tag_id}>
              <Radio
                label={tag.name}
                key={tag.tag_id}
                name="radioGroup"
                value={tag.name}
                checked={genderValue === tag.name}
                onChange={() => setRadioButton(tag.name)}
              />
            </WrapTagCheckbox>
          ))}
        {!!tags && (
          <React.Fragment>
            {tags.map((tag) => (
              <WrapTagCheckbox key={tag.tag_id}>
                <Checkbox
                  key={tag.tag_id}
                  label={`${tag.name}`}
                  name={tag.id}
                  onChange={() => handleCheck(tag)}
                  checked={category.includes(tag.tag_id)}
                />
              </WrapTagCheckbox>
            ))}
            <EmptyFilterBlock />
            <EmptyFilterBlock />
            <EmptyFilterBlock />
            <EmptyFilterBlock />
            <EmptyFilterBlock />
          </React.Fragment>
        )}
      </CheckboxWrapper>
    </div>
  );
};

export default ExceptCategoryBlock;

const H1 = styled.h1`
  text-align: center;
  font-size: 20px;
  margin-top: 20px !important;
`;



// WEBPACK FOOTER //
// ./src/Components/Common/ExceptCategoryBlock.jsx